import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function presentValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const notPresent = !control.value || control.value.trim().length === 0;
    return notPresent ? { present: true } : null;
  };
}
